import React, { useEffect } from 'react';
import './Testing.css';

const Testing = () => {
    useEffect(() => {
        const elements = document.querySelectorAll('.animate-on-scroll');
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add('animate');
                    }
                });
            },
            { threshold: 0.2 }
        );

        elements.forEach((element) => observer.observe(element));

        return () => {
            elements.forEach((element) => observer.unobserve(element));
        };
    }, []);

    const keyTopics = [
        {
            title: "Hardware QC & QA Process",
            description: "Conducting quality control and assurance to ensure hardware reliability in IoT devices."
        },
        {
            title: "Functionality Tests Process",
            description: "Performing tests to verify that IoT device functions meet design specifications."
        },
        {
            title: "Integration and Systems Test Process",
            description: "Testing integrated systems to ensure seamless operation in embedded environments."
        },
        {
            title: "Stress Tests Process",
            description: "Subjecting devices to extreme conditions to validate durability and performance."
        },
        {
            title: "Acceptance Test Process",
            description: "Conducting final acceptance tests to confirm IoT devices meet client requirements."
        },
        {
            title: "Compliance Tests Process",
            description: "Ensuring devices comply with industry standards and regulatory requirements."
        }
    ];

    return (
        <div className="detail-page">
            <h1 className="detail-heading animate-on-scroll" style={{ animationDelay: '0.1s' }}>
                Advanced Testing
            </h1>
            <p className="detail-intro animate-on-scroll" style={{ animationDelay: '0.2s' }}>
                Our advanced testing services ensure the reliability, performance, and compliance of IoT and embedded systems through rigorous quality and functional assessments.
            </p>
            <h2 className="detail-subheading animate-on-scroll" style={{ animationDelay: '0.3s' }}>
                Key Topics
            </h2>
            <ul className="detail-topics">
                {keyTopics.map((topic, index) => (
                    <li
                        key={index}
                        className="topic-card animate-on-scroll"
                        style={{ animationDelay: `${0.4 + index * 0.05}s` }}
                    >
                        <strong className="topic-title">{topic.title}</strong>
                        <p className="topic-description">{topic.description}</p>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default Testing;